<ui-input-wrapper
  [label]="base.label"
  [labelTemplate]="base.labelTemplate"
  [help]="base.help"
  [errors]="control.errors"
  [submitted]="submitted"
  [control]="control"
  [randomInputId]="randomInputId">
  <p-multiselect
    class="w-full"
    [options]="select.options()"
    [formControl]="$any(control)"
    appendTo="body"
    [panelStyleClass]="panelStyleClass"
    [showClear]="true"
    [filter]="select.searchable()"
    [placeholder]="base.placeholder ? base.placeholder : 'Vyberte'"
    [overlayOptions]="{ baseZIndex: 10004 }"
    [readonly]="base.readonly()"
    emptyFilterMessage="Nebyla nalezena shoda"
    (onClear)="clear()"
    (onChange)="handleChange.emit($event)"
    (onPanelShow)="onPanelShowHandler()"
    (onPanelHide)="dropdown.dropdownStateChange.emit(dropdownState.Closed)"
    [optionLabel]="dropdown.bindLabel()"
    [optionValue]="dropdown.bindValue()"
    [inputId]="randomInputId"
    [maxSelectedLabels]="select.maxSelectedLabels()"
    selectedItemsLabel="Vybráno: {0}">
    <!-- Položka; zakázaná nese vysvětlení v data-disabled-hint, které při najetí ukáže pravidlo ve forms.css knihovny -->
    <ng-template #item let-option>
      <div
        [ngClass]="{ 'disabled-multiselect-item': option.disabled }"
        class="{{ option.labelClass ?? '' }}"
        [attr.data-disabled-hint]="option.disabled ? (option.disabledHint ?? disabledItemHint()) : null">
        {{ option.label }}
      </div>
    </ng-template>
  </p-multiselect>
</ui-input-wrapper>
